import { render, staticRenderFns } from "./image-aspect-ratio.vue?vue&type=template&id=5497226f&scoped=true"
import script from "./image-aspect-ratio.vue?vue&type=script&lang=js"
export * from "./image-aspect-ratio.vue?vue&type=script&lang=js"
import style0 from "./image-aspect-ratio.vue?vue&type=style&index=0&id=5497226f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497226f",
  null
  
)

export default component.exports